import React, { useEffect, useState } from "react";
import { FaUser, FaMapMarkerAlt, FaEnvelope, FaPhone, FaHome, FaSave, FaTimes } from "react-icons/fa";
import stylesTable from "../../styles/applicant/ApplicantProfile.module.css";

const ApplicantProfile = ({ onClose }) => {
    const [formData, setFormData] = useState({
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        phone: "",
        //division: "",
        district: "",
        taluka: "",
        village: "",
        address: "",
    });

    // Maharashtra location data with district and taluka
    const locationData = [
        { district: "Ahilyanagar", taluka: "Ahilyanagar" },
        { district: "Ahilyanagar", taluka: "Akole" },
        { district: "Ahilyanagar", taluka: "Jamkhed" },
        { district: "Ahilyanagar", taluka: "Karjat" },
        { district: "Ahilyanagar", taluka: "Kopargaon" },
        { district: "Ahilyanagar", taluka: "Nevasa" },
        { district: "Ahilyanagar", taluka: "Parner" },
        { district: "Ahilyanagar", taluka: "Pathardi" },
        { district: "Ahilyanagar", taluka: "Rahta" },
        { district: "Ahilyanagar", taluka: "Rahuri" },
        { district: "Ahilyanagar", taluka: "Sangamner" },
        { district: "Ahilyanagar", taluka: "Shevgaon" },
        { district: "Ahilyanagar", taluka: "Shrigonda" },
        { district: "Ahilyanagar", taluka: "Shrirampur" },

        //akola
        { district: "Akola", taluka: "Akola" },
        { district: "Akola", taluka: "Akot" },
        { district: "Akola", taluka: "Balapur" },
        { district: "Akola", taluka: "Barshitakli" },
        { district: "Akola", taluka: "Murtijapur" },
        { district: "Akola", taluka: "Patur" },
        { district: "Akola", taluka: "Telhara" },
        //amravati
        { district: "Amravati", taluka: "Achalpur" },
        { district: "Amravati", taluka: "Amravati" },
        { district: "Amravati", taluka: "Anjangaon Surji" },
        { district: "Amravati", taluka: "Bhatkuli" },
        { district: "Amravati", taluka: "Chandur Railway" },
        { district: "Amravati", taluka: "Chandurbazar" },
        { district: "Amravati", taluka: "Chikhaldara" },
        { district: "Amravati", taluka: "Daryapur" },
        { district: "Amravati", taluka: "Dhamangaon Railway" },
        { district: "Amravati", taluka: "Dharni" },
        { district: "Amravati", taluka: "Morshi" },
        { district: "Amravati", taluka: "Nandgaon-Khandeshwar" },
        { district: "Amravati", taluka: "Tiosa" },
        { district: "Amravati", taluka: "Warud" },
        //beed
        { district: "Beed", taluka: "Ambejogai" },
        { district: "Beed", taluka: "Ashti" },
        { district: "Beed", taluka: "Beed" },
        { district: "Beed", taluka: "Dharur" },
        { district: "Beed", taluka: "Georai" },
        { district: "Beed", taluka: "Kaij" },
        { district: "Beed", taluka: "Majalgaon" },
        { district: "Beed", taluka: "Parli" },
        { district: "Beed", taluka: "Patoda" },
        { district: "Beed", taluka: "Shirur (Kasar)" },
        { district: "Beed", taluka: "Wadwani" },

        { district: "Bhandara", taluka: "Bhandara" },
        { district: "Bhandara", taluka: "Lakhandur" },
        { district: "Bhandara", taluka: "Lakhani" },
        { district: "Bhandara", taluka: "Mohadi" },
        { district: "Bhandara", taluka: "Pauni" },
        { district: "Bhandara", taluka: "Sakoli" },
        { district: "Bhandara", taluka: "Tumsar" },

        //buldhana
        { district: "Buldhana", taluka: "Buldana" },
        { district: "Buldhana", taluka: "Chikhli" },
        { district: "Buldhana", taluka: "Deolgaon Raja" },
        { district: "Buldhana", taluka: "Jalgaon (Jamod)" },
        { district: "Buldhana", taluka: "Khamgaon" },
        { district: "Buldhana", taluka: "Lonar" },
        { district: "Buldhana", taluka: "Malkapur" },
        { district: "Buldhana", taluka: "Mehkar" },
        { district: "Buldhana", taluka: "Motala" },
        { district: "Buldhana", taluka: "Nandura" },
        { district: "Buldhana", taluka: "Sangrampur" },
        { district: "Buldhana", taluka: "Shegaon" },
        { district: "Buldhana", taluka: "Sindkhed Raja" },

        { district: "Chandrapur", taluka: "Ballarpur" },
        { district: "Chandrapur", taluka: "Bhadravati" },
        { district: "Chandrapur", taluka: "Brahmapuri" },
        { district: "Chandrapur", taluka: "Chandrapur" },
        { district: "Chandrapur", taluka: "Chimur" },
        { district: "Chandrapur", taluka: "Gondpipri" },
        { district: "Chandrapur", taluka: "Jiwati" },
        { district: "Chandrapur", taluka: "Korpana" },
        { district: "Chandrapur", taluka: "Mul" },
        { district: "Chandrapur", taluka: "Nagbhid" },
        { district: "Chandrapur", taluka: "Pombhurna" },
        { district: "Chandrapur", taluka: "Rajura" },
        { district: "Chandrapur", taluka: "Sawali" },
        { district: "Chandrapur", taluka: "Sindewahi" },
        { district: "Chandrapur", taluka: "Warora" },

        //chhatrapati sambhaji nagar
        { district: "Chhatrapati Sambhaji Nagar", taluka: "Chhatrapati Sambhaji Nagar" },
        { district: "Chhatrapati Sambhaji Nagar", taluka: "Gangapur" },
        { district: "Chhatrapati Sambhaji Nagar", taluka: "Kannad" },
        { district: "Chhatrapati Sambhaji Nagar", taluka: "Khuldabad" },
        { district: "Chhatrapati Sambhaji Nagar", taluka: "Paithan" },
        { district: "Chhatrapati Sambhaji Nagar", taluka: "Phulambri" },
        { district: "Chhatrapati Sambhaji Nagar", taluka: "Sillod" },
        { district: "Chhatrapati Sambhaji Nagar", taluka: "Soegaon" },
        { district: "Chhatrapati Sambhaji Nagar", taluka: "Vaijapur" },

        // dharashiv
        { district: "Dharashiv", taluka: "Bhum" },
        { district: "Dharashiv", taluka: "Dharashiv" },
        { district: "Dharashiv", taluka: "Kalamb" },
        { district: "Dharashiv", taluka: "Lohara" },
        { district: "Dharashiv", taluka: "Omarga" },
        { district: "Dharashiv", taluka: "Paranda" },
        { district: "Dharashiv", taluka: "Tuljapur" },
        { district: "Dharashiv", taluka: "Washi" },

        { district: "Dhule", taluka: "Dhule" },
        { district: "Dhule", taluka: "Sakri" },
        { district: "Dhule", taluka: "Shirpur" },
        { district: "Dhule", taluka: "Sindkhede" },

        { district: "Gadchiroli", taluka: "Aheri" },
        { district: "Gadchiroli", taluka: "Armori" },
        { district: "Gadchiroli", taluka: "Bhamragad" },
        { district: "Gadchiroli", taluka: "Chamorshi" },
        { district: "Gadchiroli", taluka: "Desaiganj (Vadasa)" },
        { district: "Gadchiroli", taluka: "Dhanora" },
        { district: "Gadchiroli", taluka: "Etapalli" },
        { district: "Gadchiroli", taluka: "Gadchiroli" },
        { district: "Gadchiroli", taluka: "Korchi" },
        { district: "Gadchiroli", taluka: "Kurkheda" },
        { district: "Gadchiroli", taluka: "Mulchera" },
        { district: "Gadchiroli", taluka: "Sironcha" },

        { district: "Gondia", taluka: "Amgaon" },
        { district: "Gondia", taluka: "Arjuni Morgaon" },
        { district: "Gondia", taluka: "Deori" },
        { district: "Gondia", taluka: "Gondiya" },
        { district: "Gondia", taluka: "Goregaon" },
        { district: "Gondia", taluka: "Sadak-Arjuni" },
        { district: "Gondia", taluka: "Salekasa" },
        { district: "Gondia", taluka: "Tirora" },

        // hingoli
        { district: "Hingoli", taluka: "Aundha (Nagnath)" },
        { district: "Hingoli", taluka: "Hingoli" },
        { district: "Hingoli", taluka: "Kalamnuri" },
        { district: "Hingoli", taluka: "Sengaon" },
        { district: "Hingoli", taluka: "Vasmath" },

        { district: "Jalgaon", taluka: "Amalner" },
        { district: "Jalgaon", taluka: "Bhadgaon" },
        { district: "Jalgaon", taluka: "Bhusawal" },
        { district: "Jalgaon", taluka: "Bodvad" },
        { district: "Jalgaon", taluka: "Chalisgaon" },
        { district: "Jalgaon", taluka: "Chopda" },
        { district: "Jalgaon", taluka: "Dharangaon" },
        { district: "Jalgaon", taluka: "Erandol" },
        { district: "Jalgaon", taluka: "Jalgaon" },
        { district: "Jalgaon", taluka: "Jamner" },
        { district: "Jalgaon", taluka: "Muktainagar (Edlabad)" },
        { district: "Jalgaon", taluka: "Pachora" },
        { district: "Jalgaon", taluka: "Parola" },
        { district: "Jalgaon", taluka: "Raver" },
        { district: "Jalgaon", taluka: "Yawal" },

        //jalna
        { district: "Jalna", taluka: "Ambad" },
        { district: "Jalna", taluka: "Badnapur" },
        { district: "Jalna", taluka: "Bhokardan" },
        { district: "Jalna", taluka: "Ghansawangi" },
        { district: "Jalna", taluka: "Jafrabad" },
        { district: "Jalna", taluka: "Jalna" },
        { district: "Jalna", taluka: "Mantha" },
        { district: "Jalna", taluka: "Partur" },

        { district: "Kolhapur", taluka: "Ajra" },
        { district: "Kolhapur", taluka: "Bhudargad" },
        { district: "Kolhapur", taluka: "Chandgad" },
        { district: "Kolhapur", taluka: "Gadhinglaj" },
        { district: "Kolhapur", taluka: "Gaganbawada" },
        { district: "Kolhapur", taluka: "Hatkanangle" },
        { district: "Kolhapur", taluka: "Kagal" },
        { district: "Kolhapur", taluka: "Karvir" },
        { district: "Kolhapur", taluka: "Panhala" },
        { district: "Kolhapur", taluka: "Radhanagari" },
        { district: "Kolhapur", taluka: "Shahuwadi" },
        { district: "Kolhapur", taluka: "Shirol" },

        //latur
        { district: "Latur", taluka: "Ahmadpur" },
        { district: "Latur", taluka: "Ausa" },
        { district: "Latur", taluka: "Chakur" },
        { district: "Latur", taluka: "Deoni" },
        { district: "Latur", taluka: "Jalkot" },
        { district: "Latur", taluka: "Latur" },
        { district: "Latur", taluka: "Nilanga" },
        { district: "Latur", taluka: "Renapur" },
        { district: "Latur", taluka: "Shirur Anantpal" },
        { district: "Latur", taluka: "Udgir" },

        { district: "Nagpur", taluka: "Bhiwapur" },
        { district: "Nagpur", taluka: "Hingna" },
        { district: "Nagpur", taluka: "Kalameshwar" },
        { district: "Nagpur", taluka: "Kamptee" },
        { district: "Nagpur", taluka: "Katol" },
        { district: "Nagpur", taluka: "Kuhi" },
        { district: "Nagpur", taluka: "Mauda" },
        { district: "Nagpur", taluka: "Nagpur (Rural)" },
        { district: "Nagpur", taluka: "Nagpur (Urban)" },
        { district: "Nagpur", taluka: "Narkhed" },
        { district: "Nagpur", taluka: "Parseoni" },
        { district: "Nagpur", taluka: "Ramtek" },
        { district: "Nagpur", taluka: "Savner" },
        { district: "Nagpur", taluka: "Umred" },

        // nanded
        { district: "Nanded", taluka: "Ardhapur" },
        { district: "Nanded", taluka: "Bhokar" },
        { district: "Nanded", taluka: "Biloli" },
        { district: "Nanded", taluka: "Deglur" },
        { district: "Nanded", taluka: "Dharmabad" },
        { district: "Nanded", taluka: "Hadgaon" },
        { district: "Nanded", taluka: "Himayatnagar" },
        { district: "Nanded", taluka: "Kandhar" },
        { district: "Nanded", taluka: "Kinwat" },
        { district: "Nanded", taluka: "Loha" },
        { district: "Nanded", taluka: "Mahur" },
        { district: "Nanded", taluka: "Mudkhed" },
        { district: "Nanded", taluka: "Mukhed" },
        { district: "Nanded", taluka: "Naigaon (Khairgaon)" },
        { district: "Nanded", taluka: "Nanded" },
        { district: "Nanded", taluka: "Umri" },

        { district: "Nandurbar", taluka: "Akkalkuwa" },
        { district: "Nandurbar", taluka: "Akrani" },
        { district: "Nandurbar", taluka: "Nandurbar" },
        { district: "Nandurbar", taluka: "Nawapur" },
        { district: "Nandurbar", taluka: "Shahade" },
        { district: "Nandurbar", taluka: "Talode" },

        { district: "Nashik", taluka: "Baglan" },
        { district: "Nashik", taluka: "Chandvad" },
        { district: "Nashik", taluka: "Deola" },
        { district: "Nashik", taluka: "Dindori" },
        { district: "Nashik", taluka: "Igatpuri" },
        { district: "Nashik", taluka: "Kalwan" },
        { district: "Nashik", taluka: "Malegaon" },
        { district: "Nashik", taluka: "Nandgaon" },
        { district: "Nashik", taluka: "Nashik" },
        { district: "Nashik", taluka: "Niphad" },
        { district: "Nashik", taluka: "Peth" },
        { district: "Nashik", taluka: "Sinnar" },
        { district: "Nashik", taluka: "Surgana" },
        { district: "Nashik", taluka: "Trimbakeshwar" },
        { district: "Nashik", taluka: "Yevla" },

        // palghar
        { district: "Palghar", taluka: "Dahanu" },
        { district: "Palghar", taluka: "Jawhar" },
        { district: "Palghar", taluka: "Mokhada" },
        { district: "Palghar", taluka: "Palghar" },
        { district: "Palghar", taluka: "Talasari" },
        { district: "Palghar", taluka: "Vasai" },
        { district: "Palghar", taluka: "Vikramgad" },
        { district: "Palghar", taluka: "Wada" },
        //parbhani
        { district: "Parbhani", taluka: "Gangakhed" },
        { district: "Parbhani", taluka: "Jintur" },
        { district: "Parbhani", taluka: "Manwath" },
        { district: "Parbhani", taluka: "Palam" },
        { district: "Parbhani", taluka: "Parbhani" },
        { district: "Parbhani", taluka: "Pathri" },
        { district: "Parbhani", taluka: "Purna" },
        { district: "Parbhani", taluka: "Selu" },
        { district: "Parbhani", taluka: "Sonpeth" },
        //pune
        { district: "Pune", taluka: "Ambegaon" },
        { district: "Pune", taluka: "Baramati" },
        { district: "Pune", taluka: "Bhor" },
        { district: "Pune", taluka: "Daund" },
        { district: "Pune", taluka: "Haveli" },
        { district: "Pune", taluka: "Indapur" },
        { district: "Pune", taluka: "Junnar" },
        { district: "Pune", taluka: "Khed" },
        { district: "Pune", taluka: "Mawal" },
        { district: "Pune", taluka: "Mulshi" },
        { district: "Pune", taluka: "Pune City" },
        { district: "Pune", taluka: "Purandhar" },
        { district: "Pune", taluka: "Shirur" },
        { district: "Pune", taluka: "Velhe" },
        //Raigad
        { district: "Raigad", taluka: "Alibag" },
        { district: "Raigad", taluka: "Karjat" },
        { district: "Raigad", taluka: "Khalapur" },
        { district: "Raigad", taluka: "Mahad" },
        { district: "Raigad", taluka: "Mangaon" },
        { district: "Raigad", taluka: "Mhasla" },
        { district: "Raigad", taluka: "Murud" },
        { district: "Raigad", taluka: "Panvel" },
        { district: "Raigad", taluka: "Pen" },
        { district: "Raigad", taluka: "Poladpur" },
        { district: "Raigad", taluka: "Roha" },
        { district: "Raigad", taluka: "Shrivardhan" },
        { district: "Raigad", taluka: "Sudhagad" },
        { district: "Raigad", taluka: "Tala" },
        { district: "Raigad", taluka: "Uran" },

        { district: "Ratnagiri", taluka: "Chiplun" },
        { district: "Ratnagiri", taluka: "Dapoli" },
        { district: "Ratnagiri", taluka: "Guhagar" },
        { district: "Ratnagiri", taluka: "Khed" },
        { district: "Ratnagiri", taluka: "Lanja" },
        { district: "Ratnagiri", taluka: "Mandangad" },
        { district: "Ratnagiri", taluka: "Rajapur" },
        { district: "Ratnagiri", taluka: "Ratnagiri" },
        { district: "Ratnagiri", taluka: "Sangameshwar" },

        { district: "Sangli", taluka: "Atpadi" },
        { district: "Sangli", taluka: "Jat" },
        { district: "Sangli", taluka: "Kadegaon" },
        { district: "Sangli", taluka: "Kavathemahankal" },
        { district: "Sangli", taluka: "Khanapur" },
        { district: "Sangli", taluka: "Miraj" },
        { district: "Sangli", taluka: "Palus" },
        { district: "Sangli", taluka: "Shirala" },
        { district: "Sangli", taluka: "Tasgaon" },
        { district: "Sangli", taluka: "Walwa" },

        { district: "Satara", taluka: "Jaoli" },
        { district: "Satara", taluka: "Karad" },
        { district: "Satara", taluka: "Khandala" },
        { district: "Satara", taluka: "Khatav" },
        { district: "Satara", taluka: "Koregaon" },
        { district: "Satara", taluka: "Mahabaleshwar" },
        { district: "Satara", taluka: "Man" },
        { district: "Satara", taluka: "Patan" },
        { district: "Satara", taluka: "Phaltan" },
        { district: "Satara", taluka: "Satara" },
        { district: "Satara", taluka: "Wai" },

        { district: "Sindhudurg", taluka: "Devgad" },
        { district: "Sindhudurg", taluka: "Dodamarg" },
        { district: "Sindhudurg", taluka: "Kankavli" },
        { district: "Sindhudurg", taluka: "Kudal" },
        { district: "Sindhudurg", taluka: "Malwan" },
        { district: "Sindhudurg", taluka: "Sawantwadi" },
        { district: "Sindhudurg", taluka: "Vaibhavvadi" },
        { district: "Sindhudurg", taluka: "Vengurla" },

        { district: "Solapur", taluka: "Akkalkot" },
        { district: "Solapur", taluka: "Barshi" },
        { district: "Solapur", taluka: "Karmala" },
        { district: "Solapur", taluka: "Madha" },
        { district: "Solapur", taluka: "Malshiras" },
        { district: "Solapur", taluka: "Mangalvedhe" },
        { district: "Solapur", taluka: "Mohol" },
        { district: "Solapur", taluka: "Pandharpur" },
        { district: "Solapur", taluka: "Sangole" },
        { district: "Solapur", taluka: "Solapur North" },
        { district: "Solapur", taluka: "Solapur South" },

        { district: "Thane", taluka: "Ambarnath" },
        { district: "Thane", taluka: "Bhiwandi" },
        { district: "Thane", taluka: "Kalyan" },
        { district: "Thane", taluka: "Murbad" },
        { district: "Thane", taluka: "Shahapur" },
        { district: "Thane", taluka: "Thane" },
        { district: "Thane", taluka: "Ulhasnagar" },

        { district: "Wardha", taluka: "Arvi" },
        { district: "Wardha", taluka: "Ashti" },
        { district: "Wardha", taluka: "Deoli" },
        { district: "Wardha", taluka: "Hinganghat" },
        { district: "Wardha", taluka: "Karanja" },
        { district: "Wardha", taluka: "Samudrapur" },
        { district: "Wardha", taluka: "Seloo" },
        { district: "Wardha", taluka: "Wardha" },

        // washim
        { district: "Washim", taluka: "Karanja" },
        { district: "Washim", taluka: "Malegaon" },
        { district: "Washim", taluka: "Mangrulpir" },
        { district: "Washim", taluka: "Manora" },
        { district: "Washim", taluka: "Risod" },
        { district: "Washim", taluka: "Washim" },
        // yavatmal
        { district: "Yavatmal", taluka: "Arni" },
        { district: "Yavatmal", taluka: "Babulgaon" },
        { district: "Yavatmal", taluka: "Darwha" },
        { district: "Yavatmal", taluka: "Digras" },
        { district: "Yavatmal", taluka: "Ghatanji" },
        { district: "Yavatmal", taluka: "Kalamb" },
        { district: "Yavatmal", taluka: "Kelapur" },
        { district: "Yavatmal", taluka: "Mahagaon" },
        { district: "Yavatmal", taluka: "Maregaon" },
        { district: "Yavatmal", taluka: "Ner" },
        { district: "Yavatmal", taluka: "Pusad" },
        { district: "Yavatmal", taluka: "Ralegaon" },
        { district: "Yavatmal", taluka: "Umarkhed" },
        { district: "Yavatmal", taluka: "Wani" },
        { district: "Yavatmal", taluka: "Yavatmal" },
        { district: "Yavatmal", taluka: "Zari-Jamani" },


    ];

    // Get unique divisions
    const divisions = [...new Set(locationData.map(item => item.division))];
    const token = localStorage.getItem("token");
    // Get districts for selected division
    const getDistricts1 = (division) => {
        if (!division) return [];
        return [...new Set(locationData
            .filter(item => item.division === division)
            .map(item => item.district)
        )];
    };

    // Get talukas for selected district
    const getTalukas1 = (division, district) => {
        if (!division || !district) return [];
        return locationData
            .filter(item => item.division === division && item.district === district)
            .map(item => item.taluka);
    };

    // const [districts, setDistricts] = useState([]);
    const [talukas, setTalukas] = useState([]);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        const getProfile = async () => {
            try {
                {/* 
                const response = await fetch(
                    `${process.env.REACT_APP_SERVER_URL}/get_applicant_profile.php`,
                    {
                        credentials: "include",
                    }
                );
                */}
                const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/get_applicant_profile.php`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    //body: formData, // Make sure `formData` is a valid FormData object
                    credentials: 'include'
                });
                const result = await response.json();

                console.log(result.profile);
                if (result.status === "success") {
                    setFormData({
                        firstName: result.profile.first_name || "",
                        middleName: result.profile.middle_name || "",
                        lastName: result.profile.last_name || "",
                        email: result.profile.email || "",
                        phone: result.profile.phone || "",
                        // division: result.profile.division || "",
                        // division: result.profile.division || "",
                        district: result.profile.district || "",
                        taluka: result.profile.taluka || "",
                        village: result.profile.village || "",
                        address: result.profile.address || "",
                    });

                    // Initialize districts and talukas based on saved profile
                    // if (result.profile.division) {
                    //      setDistricts(getDistricts(result.profile.division));
                    //  }
                    //if (result.profile.division && result.profile.district) {
                    // setTalukas(getTalukas(result.profile.division, result.profile.district));
                    //}
                    if (result.profile.district) {
                        setTalukas(getTalukas(result.profile.district));
                    }
                } else {
                    console.error("Failed to fetch profile data:", result.message);
                }
            } catch (error) {
                console.error("Error fetching profile:", error);
            }
        };

        getProfile();
    }, []);

    // Update districts when division changes

    {/* 
    useEffect(() => {
        if (formData.division) {
            const filteredDistricts = getDistricts(formData.division);
            setDistricts(filteredDistricts);
            // Reset district and taluka when division changes
            setFormData(prev => ({ ...prev, district: "", taluka: "" }));
            setTalukas([]);
        } else {
            setDistricts([]);
            setTalukas([]);
        }
    }, [formData.division]);
    

    // Update talukas when district changes
    useEffect(() => {
        if (formData.division && formData.district) {
            const filteredTalukas = getTalukas(formData.division, formData.district);
            setTalukas(filteredTalukas);
            // Reset taluka when district changes
            setFormData(prev => ({ ...prev, taluka: "" }));
        } else {
            setTalukas([]);
        }
    }, [formData.district]);
    */}
    useEffect(() => {
        if (formData.district) {
            const filteredTalukas = getTalukas(formData.district);
            setTalukas(filteredTalukas);
            setFormData(prev => ({ ...prev, taluka: "" }));
        } else {
            setTalukas([]);
        }
    }, [formData.district]);

    const districts1 = [...new Set(locationData.map(item => item.district))];


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setIsSaving(true);

        try {
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/edit_applicant_profile.php`,
                {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify(formData),
                }
            );

            const result = await response.json();

            if (result.status === "success") {
                onClose();
            } else {
                console.error("Error updating profile:", result.message);
            }
        } catch (error) {
            console.error("Error updating profile:", error);
        } finally {
            setIsSaving(false);
        }
    };


    const getDistricts = () => [...new Set(locationData.map(item => item.district))];

    const getTalukas = (district) => {
        if (!district) return [];
        return locationData
            .filter(item => item.district === district)
            .map(item => item.taluka);
    };

    const [districts, setDistricts] = useState(getDistricts());




    return (
        <div className={stylesTable.overlay}>
            <div className={stylesTable.profileContainer}>
                <div className={stylesTable.header}>
                    <h2 className={stylesTable.heading}>
                        <FaUser className={stylesTable.headerIcon} />
                        Edit Your Profile
                    </h2>
                    <button className={stylesTable.closeBtn} onClick={onClose} aria-label="Close">
                        <FaTimes />
                    </button>
                </div>

                <form onSubmit={handleSave} className={stylesTable.profileForm}>
                    <div className={stylesTable.twoColumnLayout}>
                        {/* Personal Information Column */}
                        <div className={stylesTable.formColumn}>
                            <div className={stylesTable.section}>
                                <h3 className={stylesTable.sectionTitle}>
                                    <FaUser className={stylesTable.sectionIcon} />
                                    Personal Information
                                </h3>

                                <div className={stylesTable.formGroup}>
                                    <label htmlFor="firstName">First Name</label>
                                    <input
                                        type="text"
                                        id="firstName"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        className={stylesTable.inputField}
                                    />
                                </div>

                                <div className={stylesTable.formGroup}>
                                    <label htmlFor="middleName">Middle Name</label>
                                    <input
                                        type="text"
                                        id="middleName"
                                        name="middleName"
                                        value={formData.middleName}
                                        onChange={handleChange}
                                        className={stylesTable.inputField}
                                    />
                                </div>

                                <div className={stylesTable.formGroup}>
                                    <label htmlFor="lastName">Last Name</label>
                                    <input
                                        type="text"
                                        id="lastName"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        className={stylesTable.inputField}
                                    />
                                </div>
                            </div>

                            <div className={stylesTable.section}>
                                <h3 className={stylesTable.sectionTitle}>
                                    <FaEnvelope className={stylesTable.sectionIcon} />
                                    Contact Information
                                </h3>

                                <div className={stylesTable.formGroup}>
                                    <label htmlFor="email">Email</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className={stylesTable.inputField}
                                    />
                                </div>

                                <div className={stylesTable.formGroup}>
                                    <label htmlFor="phone">Mobile Number</label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className={stylesTable.inputField}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Location Information Column */}
                        <div className={stylesTable.formColumn}>
                            <div className={stylesTable.section}>
                                <h3 className={stylesTable.sectionTitle}>
                                    <FaMapMarkerAlt className={stylesTable.sectionIcon} />
                                    Location Details
                                </h3>


                                {/* 
                                <div className={stylesTable.formGroup}>
                                    <label htmlFor="division">Division</label>
                                    <select
                                        id="division"
                                        name="division"
                                        value={formData.division}
                                        onChange={handleChange}
                                        className={stylesTable.inputField}
                                    >
                                        <option value="">Select Division</option>
                                        {divisions.map(division => (
                                            <option key={division} value={division}>{division}</option>
                                        ))}
                                    </select>
                                </div>
*/}

                                {/* 
                                <div className={stylesTable.formGroup}>
                                    <label htmlFor="district">District</label>
                                    <select
                                        id="district"
                                        name="district"
                                        value={formData.district}
                                        onChange={handleChange}
                                        className={stylesTable.inputField}
                                        disabled={!formData.division}
                                    >
                                        <option value="">Select District</option>
                                        {districts.map(district => (
                                            <option key={district} value={district}>{district}</option>
                                        ))}
                                    </select>
                                </div>
*/}
                                <div className={stylesTable.formGroup}>
                                    <label>District</label>
                                    <select name="district" value={formData.district} onChange={handleChange} className={stylesTable.inputField}>
                                        <option value="">Select District</option>
                                        {districts.map((d, i) => (
                                            <option key={i} value={d}>{d}</option>
                                        ))}
                                    </select>
                                </div>


                                <div className={stylesTable.formGroup}>
                                    <label htmlFor="taluka">Taluka</label>
                                    <select
                                        id="taluka"
                                        name="taluka"
                                        value={formData.taluka}
                                        onChange={handleChange}
                                        className={stylesTable.inputField}
                                        disabled={!formData.district}
                                    >
                                        <option value="">Select Taluka</option>
                                        {talukas.map(taluka => (
                                            <option key={taluka} value={taluka}>{taluka}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className={stylesTable.formGroup}>
                                    <label htmlFor="village">Village</label>
                                    <input
                                        type="text"
                                        id="village"
                                        name="village"
                                        value={formData.village}
                                        onChange={handleChange}
                                        className={stylesTable.inputField}
                                    />
                                </div>
                            </div>

                            <div className={stylesTable.section}>
                                <h3 className={stylesTable.sectionTitle}>
                                    <FaHome className={stylesTable.sectionIcon} />
                                    Address
                                </h3>

                                <div className={stylesTable.formGroup}>
                                    <label htmlFor="address">Full Address</label>
                                    <textarea
                                        id="address"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        className={stylesTable.inputField}
                                        rows="3"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={stylesTable.formActions}>
                        <button
                            type="button"
                            className={stylesTable.cancelButton}
                            onClick={onClose}
                            disabled={isSaving}
                        >
                            <FaTimes className={stylesTable.buttonIcon} />
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={stylesTable.saveButton}
                            disabled={isSaving}
                        >
                            {isSaving ? (
                                <span className={stylesTable.spinner}></span>
                            ) : (
                                <>
                                    <FaSave className={stylesTable.buttonIcon} />
                                    Save Changes
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ApplicantProfile;